/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const IMAGE_WIDTH = 1200;
const IMAGE_HEIGHT = 628;

export const checkImageWidthAndHeight = (
  file: File | null,
  url: string | null,
) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = file ? window.URL.createObjectURL(file) : url || '';

    image.onload = () => {
      if (image.width !== IMAGE_WIDTH || image.height !== IMAGE_HEIGHT) {
        reject(
          new Error(
            `Allowed images with size only: ${IMAGE_WIDTH}px x ${IMAGE_HEIGHT}px`,
          ),
        );
      }

      resolve(true);
    };
  });
};
